var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',{staticClass:"mt-5"},[_c('render-content',{attrs:{"id":"schedulingexit"}}),_c('v-row',{staticClass:"mt-5"},_vm._l((_vm.articles),function(article,i){return _c('article-card',_vm._b({key:i},'article-card',article,false))}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }